exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-dialog .form-elegant .btn .fa[data-v-bccec82e] {\r\n    color: #2196f3!important;\n}\n.form-elegant .z-depth-1-half[data-v-bccec82e],\r\n.form-elegant .btn[data-v-bccec82e]:hover {\r\n  box-shadow: 0 5px 11px 0 rgba(85, 182, 255, 0.28), 0 4px 15px 0 rgba(36, 133, 255, 0.15);\n}\n.form-elegant .z-depth-1a[data-v-bccec82e] {\r\n  box-shadow: 0 2px 5px 0 rgba(55, 161, 255, 0.26), 0 4px 12px 0 rgba(121, 155, 254, 0.25);\n}\r\n\r\n", ""]);

// exports
